var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.981827 5.66107L10.5122 1.80293C11.4534 1.40087 14.644 0.114827 14.644 0.114827C14.644 0.114827 16.116 -0.447876 15.9927 0.918024C15.9522 1.48073 15.6256 3.45018 15.2971 5.58028L14.275 11.8907C14.275 11.8907 14.1931 12.8156 13.4967 12.9771C12.8002 13.1368 11.6567 12.4135 11.4515 12.2529C11.2887 12.1321 8.38419 10.3233 7.32066 9.43934C7.03454 9.19792 6.70701 8.71507 7.36207 8.1533C8.81889 6.83995 10.2507 5.49981 11.6567 4.1336C12.147 3.65075 12.6383 2.52628 10.5931 3.89218L4.8256 7.71131C4.8256 7.71131 4.17148 8.11337 2.94418 7.75124C1.71689 7.3891 0.285356 6.90718 0.285356 6.90718C0.285356 6.90718 -0.696292 6.30362 0.981827 5.66107Z",
    fill: "#A7ADB7",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramGrey);
export default __webpack_public_path__ + "static/media/telegramGrey.7158d6c0245b99f311af1b85efeb677c.svg";
export { ForwardRef as ReactComponent };